import { render, staticRenderFns } from "./TasksKanban.vue?vue&type=template&id=3ab7b4e5&scoped=true&"
import script from "./TasksKanban.vue?vue&type=script&lang=js&"
export * from "./TasksKanban.vue?vue&type=script&lang=js&"
import style0 from "./TasksKanban.vue?vue&type=style&index=0&id=3ab7b4e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7b4e5",
  null
  
)

export default component.exports